export const fr = {
  "app.title": "survivrr.io",
  "menu.online": "En ligne",
  "menu.offline": "Hors ligne",
  "menu.play": "Jouer",
  "menu.name": "Nom",
  "menu.ballColor": "Couleur de la boule",
  "menu.nameColor": "Couleur du nom",
  "menu.moreInfo": "Plus d’infos",
  "menu.moreInfoTitle": "Plus d’infos",
  "menu.moreInfoSubtitle": "Pages légales, détails sur les cookies et informations de contact.",
  "menu.back": "Retour",
  "menu.privacySettings": "Paramètres de confidentialité",
  "menu.cookiePolicy": "Politique relative aux cookies",
  "menu.privacyPolicy": "Politique de confidentialité",
  "menu.termsOfService": "Conditions d’utilisation",
  "menu.emailButton": "M’envoyer un e-mail",
  "menu.websiteButton": "Voir mon site",
  "menu.contactEmailLabel": "E-mail de contact :",
  "menu.emailLabel": "E-mail :",
  "menu.websiteLabel": "Voir mon site :",
  "menu.nameRequired": "Saisis d’abord un nom.",
  "moreInfo.privacySettings.intro1": "Vous pouvez gérer vos choix de confidentialité sur ce site via le message de consentement affiché par notre fournisseur de publicité lorsqu’il est disponible.",
  "moreInfo.privacySettings.intro2": "Vous pouvez aussi contrôler les cookies et le stockage local dans les paramètres de votre navigateur à tout moment.",
  "moreInfo.privacySettings.adsHeading": "Contrôles publicitaires",
  "moreInfo.privacySettings.adsParagraph": "Certaines publicités peuvent être fournies par Google ou d’autres partenaires. Les choix de publicité personnalisée peuvent aussi être gérés directement dans les paramètres publicitaires de Google.",
  "moreInfo.privacySettings.adsBullet1": "Ouvrez les contrôles publicitaires de Google sur myadcenter.google.com.",
  "moreInfo.privacySettings.adsBullet2": "Effacez les cookies ou les données du site si vous voulez réinitialiser vos choix de consentement.",
  "moreInfo.privacySettings.adsBullet3": "Utilisez les paramètres de confidentialité de votre navigateur pour bloquer ou limiter les cookies.",
  "moreInfo.privacySettings.localHeading": "Paramètres locaux",
  "moreInfo.privacySettings.localParagraph": "Ce jeu stocke des préférences locales de base, comme votre nom de joueur, vos couleurs, le son et la langue, afin que le site puisse s’en souvenir sur votre appareil.",
  "moreInfo.cookiePolicy.intro1": "Ce site utilise des cookies et des technologies de stockage similaires pour faire fonctionner le jeu, mémoriser vos paramètres et prendre en charge la publicité.",
  "moreInfo.cookiePolicy.intro2": "Les cookies peuvent aussi être utilisés pour la mesure, la prévention de la fraude et la personnalisation des annonces selon vos choix de consentement et les services activés sur le site.",
  "moreInfo.cookiePolicy.typesHeading": "Types de cookies et de stockage que nous pouvons utiliser",
  "moreInfo.cookiePolicy.typeBullet1": "Stockage essentiel utilisé pour assurer le fonctionnement du site.",
  "moreInfo.cookiePolicy.typeBullet2": "Stockage des préférences utilisé pour mémoriser votre nom, vos couleurs, votre langue et le réglage du son.",
  "moreInfo.cookiePolicy.typeBullet3": "Cookies publicitaires ou de mesure utilisés par des partenaires publicitaires comme Google lorsque les annonces sont activées.",
  "moreInfo.cookiePolicy.manageHeading": "Comment gérer les cookies",
  "moreInfo.cookiePolicy.manageParagraph": "Vous pouvez gérer les cookies via le message de consentement du site lorsqu’il est disponible, ou via les paramètres de votre navigateur. Désactiver certains cookies peut affecter des fonctionnalités du site ou la diffusion des annonces.",
  "moreInfo.privacyPolicy.intro1": "Ce site est un jeu de navigateur exploité par Michał Kierzkowski. Nous cherchons à collecter le moins d’informations personnelles possible.",
  "moreInfo.privacyPolicy.intro2": "Aucun compte n’est nécessaire pour jouer. Le jeu peut stocker des préférences locales de base sur votre appareil et traiter les données de jeu nécessaires aux parties en ligne.",
  "moreInfo.privacyPolicy.infoHeading": "Informations que nous pouvons traiter",
  "moreInfo.privacyPolicy.infoBullet1": "Votre nom de joueur choisi et vos paramètres cosmétiques.",
  "moreInfo.privacyPolicy.infoBullet2": "Les données de session de base nécessaires au fonctionnement des fonctionnalités multijoueurs.",
  "moreInfo.privacyPolicy.infoBullet3": "Des données d’appareil, de navigateur ou de publicité collectées par des partenaires d’analyse ou de publicité si ces services sont activés.",
  "moreInfo.privacyPolicy.useHeading": "Comment nous utilisons les informations",
  "moreInfo.privacyPolicy.useBullet1": "Pour faire fonctionner le jeu et les salons en ligne.",
  "moreInfo.privacyPolicy.useBullet2": "Pour mémoriser vos paramètres sur votre appareil.",
  "moreInfo.privacyPolicy.useBullet3": "Pour améliorer les performances, la sécurité et la stabilité.",
  "moreInfo.privacyPolicy.useBullet4": "Pour afficher des publicités lorsque la publicité est activée.",
  "moreInfo.privacyPolicy.contactHeading": "Contact",
  "moreInfo.privacyPolicy.contactParagraph1": "Pour toute question relative à la confidentialité, contactez : mjkierzkowski@gmail.com",
  "moreInfo.privacyPolicy.contactParagraph2": "Site web : michalkierzkowski.com",
  "moreInfo.terms.intro1": "En utilisant ce site, vous acceptez d’utiliser le jeu de manière légale et équitable.",
  "moreInfo.terms.intro2": "Le jeu est fourni tel quel et peut être modifié, interrompu ou supprimé à tout moment.",
  "moreInfo.terms.rulesHeading": "Règles",
  "moreInfo.terms.ruleBullet1": "N’abusez pas des bugs, triches, automatisations ou exploits.",
  "moreInfo.terms.ruleBullet2": "N’essayez pas de nuire au service ou aux autres joueurs.",
  "moreInfo.terms.ruleBullet3": "N’utilisez pas de noms ou contenus offensants, illégaux ou trompeurs.",
  "moreInfo.terms.limitationHeading": "Limitation",
  "moreInfo.terms.limitationParagraph": "Nous ne sommes pas responsables des pertes, interruptions ou dommages résultant de l’utilisation du site, dans la mesure maximale autorisée par la loi.",
  "moreInfo.terms.changesHeading": "Modifications",
  "moreInfo.terms.changesParagraph": "Ces conditions peuvent être mises à jour à l’avenir. Continuer à utiliser le site après une mise à jour signifie que vous acceptez les conditions mises à jour.",
  "status.offline": "Démarrage de la partie hors ligne...",
  "status.connecting": "Connexion au serveur...",
  "queue.title": "En attente d’un salon",
  "queue.menu": "Retour au menu principal",
  "game.pressToMove": "Appuyez n’importe où pour bouger",
  "game.touchToMove": "Touchez n’importe où pour bouger",
  "game.leaderboard": "Classement",
  "game.hp": "PV",
  "game.level": "Niveau",
  "game.xp": "XP",
  "game.respawning": "Réapparition...",
  "gameEnd.title": "Fin de partie",
  "gameEnd.winTitle": "Vous avez gagné",
  "gameEnd.subtitle": "La partie est terminée. Réapparaissez pour commencer la manche suivante ou retournez au menu.",
  "pause.title": "Menu du jeu",
  "pause.resume": "Continuer",
  "pause.menu": "Retour au menu principal",
  "upgrade.title": "Choisissez une amélioration",
  "upgrade.generic.title": "Amélioration",
  "upgrade.generic.description": "Améliorez votre build.",
  "upgrade.newWeaponPrefix": "Nouvelle arme :",
  "upgrade.stat.maxHp.title": "PV max",
  "upgrade.stat.maxHp.description": "Augmente les PV maximum.",
  "upgrade.stat.speed.title": "Vitesse de déplacement",
  "upgrade.stat.speed.description": "Augmente la vitesse de déplacement.",
  "upgrade.stat.generic.title": "Amélioration de stat",
  "upgrade.stat.generic.description": "Améliore vos statistiques.",
  "upgrade.weapon.projectileShot.title": "Tir de projectile",
  "upgrade.weapon.projectileShot.description": "Ajoute des tirs de projectiles à votre build.",
  "upgrade.weapon.orbitingBalls.title": "Boules orbitales",
  "upgrade.weapon.orbitingBalls.description": "Ajoute des boules orbitales à votre build.",
  "upgrade.weapon.damageZone.title": "Zone de dégâts",
  "upgrade.weapon.damageZone.description": "Ajoute une zone de dégâts autour du personnage.",
  "upgrade.weapon.generic.title": "Arme",
  "upgrade.weapon.generic.description": "Ajoutez cette arme à votre build.",
  "upgrade.weaponUpgrade.frequency.title": "Fréquence",
  "upgrade.weaponUpgrade.frequency.description": "Attaquez plus souvent.",
  "upgrade.weaponUpgrade.range.title": "Portée",
  "upgrade.weaponUpgrade.range.description": "Augmente la portée de l’arme.",
  "upgrade.weaponUpgrade.projectileCount.title": "Nombre de projectiles",
  "upgrade.weaponUpgrade.projectileCount.description": "Crée plus de projectiles.",
  "upgrade.weaponUpgrade.projectileSpeed.title": "Vitesse des projectiles",
  "upgrade.weaponUpgrade.projectileSpeed.description": "Rend les projectiles plus rapides.",
  "upgrade.weaponUpgrade.orbitalSpeed.title": "Vitesse orbitale",
  "upgrade.weaponUpgrade.orbitalSpeed.description": "Fait tourner les boules orbitales plus vite.",
  "upgrade.weaponUpgrade.damage.title": "Dégâts",
  "upgrade.weaponUpgrade.damage.description": "Inflige plus de dégâts.",
  "upgrade.weaponUpgrade.generic.title": "Amélioration d’arme",
  "upgrade.weaponUpgrade.generic.description": "Améliore cette arme.",
  "defeat.title": "Défaite",
  "defeat.subtitle": "Réapparaissez ou retournez au menu",
  "defeat.respawn": "Réapparaître",
  "defeat.menu": "Menu principal",
  "error.generic": "Une erreur est survenue.",
} as const;
